import React, { useState } from 'react';
import { auth } from '../utils/api';

export default function LoginPage({ onLogin }) {
  const [mode,     setMode]     = useState('login'); // 'login' | 'register'
  const [form,     setForm]     = useState({ username:'', password:'', confirmPassword:'', name:'', title:'' });
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const [showPass, setShowPass] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async () => {
    setError('');

    if (!form.username.trim() || !form.password) {
      setError('Username and password are required.'); return;
    }

    if (mode === 'register') {
      if (!form.name.trim()) { setError('Display name is required.'); return; }
      if (form.password.length < 6) { setError('Password must be at least 6 characters.'); return; }
      if (form.password !== form.confirmPassword) { setError('Passwords do not match.'); return; }
    }

    setLoading(true);
    try {
      const payload = mode === 'login'
        ? { username: form.username.trim(), password: form.password }
        : { username: form.username.trim(), password: form.password,
            name: form.name.trim(), title: form.title.trim() };

      const fn = mode === 'login' ? auth.login : auth.register;
      const result = await fn(payload);
      onLogin(result.token, result.player);
    } catch (e) {
      setError(e.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleKey = (e) => { if (e.key === 'Enter') handleSubmit(); };

  return (
    <div className="login-page">
      <div className="login-card">
        {/* Logo */}
        <div className="login-logo">
          <div className="login-logo-icon">⚔️</div>
          <h1 className="login-title">GAME OF LIFE</h1>
          <div className="login-subtitle">LIAM'S EDITION</div>
        </div>

        {/* Mode tabs */}
        <div className="login-tabs">
          <button
            className={`login-tab${mode === 'login' ? ' active' : ''}`}
            onClick={() => { setMode('login'); setError(''); }}
          >
            Login
          </button>
          <button
            className={`login-tab${mode === 'register' ? ' active' : ''}`}
            onClick={() => { setMode('register'); setError(''); }}
          >
            Register
          </button>
        </div>

        {/* Form */}
        <div className="login-form">
          {/* Register-only: display name */}
          {mode === 'register' && (
            <>
              <div className="form-group">
                <label className="form-label">Display Name *</label>
                <input
                  className="form-input"
                  value={form.name}
                  onChange={e => set('name', e.target.value)}
                  placeholder="How you appear to others"
                  onKeyDown={handleKey}
                  autoFocus={mode === 'register'}
                />
              </div>
              <div className="form-group">
                <label className="form-label">Title (optional)</label>
                <input
                  className="form-input"
                  value={form.title}
                  onChange={e => set('title', e.target.value)}
                  placeholder="e.g. The Mighty, Software Engineer"
                  onKeyDown={handleKey}
                />
              </div>
            </>
          )}

          <div className="form-group">
            <label className="form-label">Username *</label>
            <input
              className="form-input"
              value={form.username}
              onChange={e => set('username', e.target.value)}
              placeholder="Your login username"
              autoComplete="username"
              autoFocus={mode === 'login'}
              onKeyDown={handleKey}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password *</label>
            <div className="login-pass-wrap">
              <input
                className="form-input"
                type={showPass ? 'text' : 'password'}
                value={form.password}
                onChange={e => set('password', e.target.value)}
                placeholder={mode === 'register' ? 'At least 6 characters' : 'Your password'}
                autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
                onKeyDown={handleKey}
              />
              <button
                className="login-pass-toggle"
                type="button"
                onClick={() => setShowPass(s => !s)}
                tabIndex={-1}
              >
                {showPass ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          {mode === 'register' && (
            <div className="form-group">
              <label className="form-label">Confirm Password *</label>
              <input
                className="form-input"
                type={showPass ? 'text' : 'password'}
                value={form.confirmPassword}
                onChange={e => set('confirmPassword', e.target.value)}
                placeholder="Re-enter your password"
                autoComplete="new-password"
                onKeyDown={handleKey}
              />
            </div>
          )}

          {error && (
            <div className="login-error">
              <span>⚠</span> {error}
            </div>
          )}

          <button
            className="btn btn-primary login-submit"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading
              ? '...'
              : mode === 'login' ? '▶ Enter Game' : '⚔️ Create Account'
            }
          </button>

          {mode === 'login' && (
            <p className="login-hint">
              New here?{' '}
              <button className="login-link" onClick={() => { setMode('register'); setError(''); }}>
                Create an account
              </button>
            </p>
          )}
        </div>

        <div className="login-footer">READY PLAYER ONE</div>
      </div>
    </div>
  );
}